// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 페이지 헤더 스타일 */
.pageHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
}

.pageActions {
  display: flex;
  gap: 10px;
}

/* 버튼 스타일 - 크기 고정 및 오버플로우 처리 */
.workerActionButton {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  width: 160px !important; /* 강제 고정 너비 */
  height: 40px !important; /* 강제 고정 높이 */
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0; /* 버튼 축소 방지 */
  min-width: 160px; /* 최소 너비 설정 */
  max-width: 160px; /* 최대 너비 설정 */
}

.exportButton {
  background-color: #ffffff;
  border: 1px solid #ddd;
  color: #333;
}

.editButton {
  background-color: #ffffff;
  border: 1px solid #ddd;
  color: #333;
}

.saveButton {
  background-color: #ff6b00;
  color: white;
  border: none;
  font-size: 14px; /* 폰트 크기 조정 */
}

.exportIcon, .editIcon {
  margin-right: 8px;
}

.okIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  background-color: white;
  color: #ff6b00;
  border-radius: 2px;
  margin-right: 5px; /* 오른쪽 마진 줄임 */
  font-weight: bold;
  font-size: 12px;
  flex-shrink: 0; /* 아이콘 크기 고정 */
}

/* 월 선택과 버튼 영역 - 높이 고정 */
.monthAndButtons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
  z-index: 5;
}

/* 월 선택 컨트롤 위치 조정 */
.monthNavigation {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

/* 버튼 컨테이너 위치 고정 */
.workerActionButtons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: auto;
  position: relative;
  top: 0px;
  right: -80px;
}

/* 기존 actionButtons 클래스는 남겨두지만 사용하지 않음 - 호환성 유지 */
.actionButtons {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-left: auto;
  width: 160px;
}

.prevMonth, .nextMonth {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0 15px;
}

.currentMonth {
  font-size: 30px;
  margin: 0 20px;
  font-weight: normal;
}

/* 전체 페이지 레이아웃을 명확하게 지정 */
.workerManagementPage {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
}

/* 테이블 컨테이너 스타일 수정 */
.tableContainer {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  background-color: transparent;
  margin-bottom: 30px;
  max-height: 650px;
  z-index: 1; /* 낮은 z-index 값 설정 */
  position: relative;
}

/* 테이블 크기 조정 */
table {
  width: 100%;
  min-width: 1000px;
  border-collapse: collapse;
  table-layout: fixed;
  z-index: 1;
}

/* 사이드 메뉴 관련 스타일 추가 */
.sidebar {
  position: relative;
  z-index: 10; /* 사이드바의 z-index를 높게 설정 */
}

/* 컨텐츠 영역 스타일 */
.content {
  flex: 1 1;
  padding-left: 10px;
  overflow: visible;
  position: relative;
}

/* 기본 셀 스타일 */
th, td {
  padding: 10px 5px;
  text-align: center;
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  width: 100px; /* 셀 너비 축소 */
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 첫 번째 열 스타일 */
table th:first-child,
table td:first-child {
  width: 190px !important;
  min-width: 190px !important;
  max-width: 190px !important;
  background-color: #fde9d9;
  position: sticky;
  left: 0;
  z-index: 2;
}

/* 나머지 열 스타일 */
table th:not(:first-child),
table td:not(:first-child) {
  width: auto;
  min-width: 100px;
  max-width: none;
  flex: 1 1;
}

/* 월별 특이사항 셀 스타일 - 최대 너비 제한 */
.hasContent {
  white-space: normal !important;
  word-wrap: break-word !important;
  max-width: 200px; /* 최대 너비 줄임 */
  text-align: left;
  padding: 8px;
}

/* 월별 특이사항 입력 필드 */
.editInput.monthlyNotes {
  width: 95%;
  min-height: 60px;
  resize: vertical;
  white-space: normal;
  word-wrap: break-word;
  text-align: left;
}

/* 모든 라벨 스타일 */
.infoLabel, .dateLabel, .summaryLabel {
  text-align: center;
  font-weight: normal;
  padding: 10px 15px; /* 패딩 추가 */
}

.infoLabel {
  background-color: #fde9d9 !important;
}

.dateLabel {
  background-color: #e9eeff !important;
}

.summaryLabel {
  background-color: #f0f0f0 !important;
}

.dayOfWeek {
  color: #ff0000;
}

.overtimeHours {
  color: #ff6b00;
  margin-left: 5px;
}

/* 링크 스타일 */
.workerNameLink {
  color: black !important;
  font-weight: normal !important;
  text-decoration: none;
}

.workerNameLink:hover {
  text-decoration: underline;
}

/* 컨테이너가 일정 크기 이상일 때만 스크롤 표시 */
@media (max-width: 1200px) {
  .tableContainer {
    overflow-x: auto;
  }
  
  .monthAndButtons {
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 40px;
    height: auto; /* 모바일에서는 자동 높이 */
    padding-top: 0;
  }
  
  .monthNavigation {
    position: static;
    transform: none;
    margin-bottom: 0;
  }
  
  .workerActionButtons {
    margin-left: auto;
    flex-direction: column;
    gap: 10px;
    top: 0; /* 모바일에서는 상단 이동 없음 */
  }
}

/* 사원이름 행(헤더 행) 배경색 설정 - 월별 특이사항과 동일하게 */
table thead tr th {
  background-color: #fde9d9 !important; /* 월별 특이사항과 동일한 배경색 */
  font-weight: normal;
  color: #333;
}

/* 요약 행(총근로시간, 규정근무수당, 특별근무수당, 총 수당) 배경색 설정 */
.summaryRow td {
  background-color: #f2f2f2 !important; /* 연한 회색 */
}

/* 첫 번째 열의 요약 행 셀은 강조 표시 */
.summaryRow td:first-child {
  background-color: #e6e6e6 !important; /* 약간 더 진한 회색 */
  font-weight: normal;
}

/* 시간 입력 필드 스타일 개선 */
.editHoursContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.hoursInputRow {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 2px;
}

.editInput.dailyHours,
.editInput.overtimeHours {
  width: 40px;
  padding: 4px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 14px;
}

/* 특근시간 입력필드는 더 작게 */
.editInput.overtimeHours {
  width: 30px;
  color: #ff6b00;
}

/* 수정된 근무시간 셀 스타일 */
.modified-record {
  background-color: #f0f7ff !important;
  position: relative;
}

/* 수정 표시 아이콘 */
.modified-indicator {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 10px;
  color: #2196F3;
  cursor: help;
}`, "",{"version":3,"sources":["webpack://./src/styles/WorkerManagement.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB,EAAE,aAAa;EACtC,uBAAuB,EAAE,aAAa;EACtC,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc,EAAE,aAAa;EAC7B,gBAAgB,EAAE,aAAa;EAC/B,gBAAgB,EAAE,aAAa;AACjC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe,EAAE,aAAa;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,iBAAiB,EAAE,cAAc;EACjC,iBAAiB;EACjB,eAAe;EACf,cAAc,EAAE,cAAc;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,UAAU,EAAE,oBAAoB;EAChC,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW,EAAE,yBAAyB;AACxC;;AAEA,eAAe;AACf;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY,EAAE,YAAY;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,eAAe;AACf;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,OAAO;EACP,UAAU;AACZ;;AAEA,cAAc;AACd;;EAEE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,SAAO;AACT;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB,EAAE,aAAa;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB,EAAE,UAAU;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8BAA8B;AAC9B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,YAAY,EAAE,iBAAiB;IAC/B,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,MAAM,EAAE,oBAAoB;EAC9B;AACF;;AAEA,wCAAwC;AACxC;EACE,oCAAoC,EAAE,qBAAqB;EAC3D,mBAAmB;EACnB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC,EAAE,UAAU;AAClD;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC,EAAE,eAAe;EACrD,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;AACd","sourcesContent":["/* 페이지 헤더 스타일 */\n.pageHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0;\n}\n\n.pageActions {\n  display: flex;\n  gap: 10px;\n}\n\n/* 버튼 스타일 - 크기 고정 및 오버플로우 처리 */\n.workerActionButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  white-space: nowrap;\n  width: 160px !important; /* 강제 고정 너비 */\n  height: 40px !important; /* 강제 고정 높이 */\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex-shrink: 0; /* 버튼 축소 방지 */\n  min-width: 160px; /* 최소 너비 설정 */\n  max-width: 160px; /* 최대 너비 설정 */\n}\n\n.exportButton {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  color: #333;\n}\n\n.editButton {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  color: #333;\n}\n\n.saveButton {\n  background-color: #ff6b00;\n  color: white;\n  border: none;\n  font-size: 14px; /* 폰트 크기 조정 */\n}\n\n.exportIcon, .editIcon {\n  margin-right: 8px;\n}\n\n.okIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  min-width: 20px;\n  background-color: white;\n  color: #ff6b00;\n  border-radius: 2px;\n  margin-right: 5px; /* 오른쪽 마진 줄임 */\n  font-weight: bold;\n  font-size: 12px;\n  flex-shrink: 0; /* 아이콘 크기 고정 */\n}\n\n/* 월 선택과 버튼 영역 - 높이 고정 */\n.monthAndButtons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  position: relative;\n  z-index: 5;\n}\n\n/* 월 선택 컨트롤 위치 조정 */\n.monthNavigation {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n/* 버튼 컨테이너 위치 고정 */\n.workerActionButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-left: auto;\n  position: relative;\n  top: 0px;\n  right: -80px;\n}\n\n/* 기존 actionButtons 클래스는 남겨두지만 사용하지 않음 - 호환성 유지 */\n.actionButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-left: auto;\n  width: 160px;\n}\n\n.prevMonth, .nextMonth {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0 15px;\n}\n\n.currentMonth {\n  font-size: 30px;\n  margin: 0 20px;\n  font-weight: normal;\n}\n\n/* 전체 페이지 레이아웃을 명확하게 지정 */\n.workerManagementPage {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: visible;\n}\n\n/* 테이블 컨테이너 스타일 수정 */\n.tableContainer {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: auto;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  background-color: transparent;\n  margin-bottom: 30px;\n  max-height: 650px;\n  z-index: 1; /* 낮은 z-index 값 설정 */\n  position: relative;\n}\n\n/* 테이블 크기 조정 */\ntable {\n  width: 100%;\n  min-width: 1000px;\n  border-collapse: collapse;\n  table-layout: fixed;\n  z-index: 1;\n}\n\n/* 사이드 메뉴 관련 스타일 추가 */\n.sidebar {\n  position: relative;\n  z-index: 10; /* 사이드바의 z-index를 높게 설정 */\n}\n\n/* 컨텐츠 영역 스타일 */\n.content {\n  flex: 1;\n  padding-left: 10px;\n  overflow: visible;\n  position: relative;\n}\n\n/* 기본 셀 스타일 */\nth, td {\n  padding: 10px 5px;\n  text-align: center;\n  border: 1px solid #e0e0e0;\n  background-color: #ffffff;\n  width: 100px; /* 셀 너비 축소 */\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* 첫 번째 열 스타일 */\ntable th:first-child,\ntable td:first-child {\n  width: 190px !important;\n  min-width: 190px !important;\n  max-width: 190px !important;\n  background-color: #fde9d9;\n  position: sticky;\n  left: 0;\n  z-index: 2;\n}\n\n/* 나머지 열 스타일 */\ntable th:not(:first-child),\ntable td:not(:first-child) {\n  width: auto;\n  min-width: 100px;\n  max-width: none;\n  flex: 1;\n}\n\n/* 월별 특이사항 셀 스타일 - 최대 너비 제한 */\n.hasContent {\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  max-width: 200px; /* 최대 너비 줄임 */\n  text-align: left;\n  padding: 8px;\n}\n\n/* 월별 특이사항 입력 필드 */\n.editInput.monthlyNotes {\n  width: 95%;\n  min-height: 60px;\n  resize: vertical;\n  white-space: normal;\n  word-wrap: break-word;\n  text-align: left;\n}\n\n/* 모든 라벨 스타일 */\n.infoLabel, .dateLabel, .summaryLabel {\n  text-align: center;\n  font-weight: normal;\n  padding: 10px 15px; /* 패딩 추가 */\n}\n\n.infoLabel {\n  background-color: #fde9d9 !important;\n}\n\n.dateLabel {\n  background-color: #e9eeff !important;\n}\n\n.summaryLabel {\n  background-color: #f0f0f0 !important;\n}\n\n.dayOfWeek {\n  color: #ff0000;\n}\n\n.overtimeHours {\n  color: #ff6b00;\n  margin-left: 5px;\n}\n\n/* 링크 스타일 */\n.workerNameLink {\n  color: black !important;\n  font-weight: normal !important;\n  text-decoration: none;\n}\n\n.workerNameLink:hover {\n  text-decoration: underline;\n}\n\n/* 컨테이너가 일정 크기 이상일 때만 스크롤 표시 */\n@media (max-width: 1200px) {\n  .tableContainer {\n    overflow-x: auto;\n  }\n  \n  .monthAndButtons {\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 40px;\n    height: auto; /* 모바일에서는 자동 높이 */\n    padding-top: 0;\n  }\n  \n  .monthNavigation {\n    position: static;\n    transform: none;\n    margin-bottom: 0;\n  }\n  \n  .workerActionButtons {\n    margin-left: auto;\n    flex-direction: column;\n    gap: 10px;\n    top: 0; /* 모바일에서는 상단 이동 없음 */\n  }\n}\n\n/* 사원이름 행(헤더 행) 배경색 설정 - 월별 특이사항과 동일하게 */\ntable thead tr th {\n  background-color: #fde9d9 !important; /* 월별 특이사항과 동일한 배경색 */\n  font-weight: normal;\n  color: #333;\n}\n\n/* 요약 행(총근로시간, 규정근무수당, 특별근무수당, 총 수당) 배경색 설정 */\n.summaryRow td {\n  background-color: #f2f2f2 !important; /* 연한 회색 */\n}\n\n/* 첫 번째 열의 요약 행 셀은 강조 표시 */\n.summaryRow td:first-child {\n  background-color: #e6e6e6 !important; /* 약간 더 진한 회색 */\n  font-weight: normal;\n}\n\n/* 시간 입력 필드 스타일 개선 */\n.editHoursContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.hoursInputRow {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  gap: 2px;\n}\n\n.editInput.dailyHours,\n.editInput.overtimeHours {\n  width: 40px;\n  padding: 4px;\n  text-align: center;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 14px;\n}\n\n/* 특근시간 입력필드는 더 작게 */\n.editInput.overtimeHours {\n  width: 30px;\n  color: #ff6b00;\n}\n\n/* 수정된 근무시간 셀 스타일 */\n.modified-record {\n  background-color: #f0f7ff !important;\n  position: relative;\n}\n\n/* 수정 표시 아이콘 */\n.modified-indicator {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  font-size: 10px;\n  color: #2196F3;\n  cursor: help;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
